import { render, staticRenderFns } from "./ManageLayout.vue?vue&type=template&id=644bc21b&scoped=true"
import script from "./ManageLayout.vue?vue&type=script&lang=js"
export * from "./ManageLayout.vue?vue&type=script&lang=js"
import style0 from "./ManageLayout.vue?vue&type=style&index=0&id=644bc21b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bc21b",
  null
  
)

export default component.exports